import { Language } from "@/context/LanguageContext";

export const translations: Record<Language, Record<string, string>> = {
  en: {
    // Navigation
    'nav.home': 'Home',
    'nav.shop': 'Shop',
    'nav.extras': 'Extras',
    'nav.contact': 'Contact',
    'nav.collections': 'Collections',
    'nav.events': 'Events',
    'nav.blog': 'Blog',
    'nav.help': 'Help',
    'nav.trackOrder': 'Track Order',

    // Footer
    'footer.tagline': 'Fresh flowers, hand-picked and tied every day, delivered with care across Neamț county.',
    'footer.navigation': 'Navigation',
    'footer.contact': 'Contact',
    'footer.rights': 'All rights reserved.',
    'footer.terms': 'Terms',
    'footer.cookiePolicy': 'Cookie Policy',
    'footer.gdpr': 'GDPR',

    // Extras page
    'extras.title': 'Extras & Add-ons',
    'extras.subtitle': 'Complete your gift with special extras',
    'extras.categories': 'Categories',
    'extras.allCategories': 'All Categories',
    'extras.filterBy': 'Filter by',
    'extras.clearFilters': 'Clear Filters',
    'extras.noExtras': 'No extras found',
    'extras.addToCart': 'Add to Cart',
    'extras.viewDetails': 'View Details',
    
    // Extra categories
    'extras.category.chocolates': 'Chocolates',
    'extras.category.vases': 'Vases',
    'extras.category.cards': 'Cards',
    'extras.category.toys': 'Toys',
    'extras.category.balloons': 'Balloons',
    'extras.category.wines': 'Wines',
    'extras.category.other': 'Other',
    
    // Extra sizes
    'extras.size.small': 'Small',
    'extras.size.medium': 'Medium',
    'extras.size.large': 'Large',
    
    // Homepage
    'homepage.heroTitle': 'Welcome to',
    'homepage.heroSubtitle': 'Buchetul Simonei Poezia Florilor',
    'homepage.banner': 'Discover Fresh Flowers for Every Occasion',
    'homepage.shopNow': 'Shop Now',
    'homepage.exploreColl': 'Or explore our collections',
    'homepage.themeSwitch': 'Change the color of the background in the theme switcher',
    
    // Shop page
    'shop.title': 'Discover Our Flower Shop',
    'shop.subtitle': 'Find the perfect bouquet for any occasion from our curated selection of fresh flowers',
    'shop.search': 'Search products',
    'shop.filterBy': 'Filter by',
    'shop.allCategories': 'All Categories',
    'shop.clearFilters': 'Clear Filters',
    'shop.noProducts': 'No products found',
    'shop.tryDifferentSearch': 'Try adjusting your search or filter criteria',
    'shop.showFilters': 'Show Filters',
    'shop.hideFilters': 'Hide Filters',
    'shop.mobileFilters': 'Filters',
    'shop.categories': 'Categories',
    'shop.colors': 'Colors',
    'shop.occasions': 'Occasions',
    'shop.sortBy': 'Sort by',
    'shop.sameDayDelivery': 'Same-day delivery',
    'shop.clearAll': 'Clear All',
    
    // Sort options
    'shop.sort.featured': 'Featured',
    'shop.sort.priceAsc': 'Price: Low to High',
    'shop.sort.priceDesc': 'Price: High to Low',
    'shop.sort.newest': 'Newest',
    'shop.sort.rating': 'Best Rated',
    
    // Colors
    'shop.color.rosu': 'Red',
    'shop.color.roz': 'Pink',
    'shop.color.alb': 'White',
    'shop.color.galben': 'Yellow',
    'shop.color.mov': 'Purple',
    'shop.color.portocaliu': 'Orange',
    'shop.color.albastru': 'Blue',
    'shop.color.mixt': 'Mixed',
    'shop.color.pastel': 'Pastel',
    'shop.color.negru': 'Black',
    
    // Occasions
    'shop.occasion.birthday': 'Birthday',
    'shop.occasion.anniversary': 'Anniversary',
    'shop.occasion.wedding': 'Wedding',
    'shop.occasion.funeral': 'Funeral',
    'shop.occasion.romantic': 'Romantic',
    'shop.occasion.congratulations': 'Congratulations',
    'shop.occasion.getWell': 'Get Well',
    'shop.occasion.thankYou': 'Thank You',
    'shop.occasion.justBecause': 'Just Because',
    'shop.occasion.mothersDay': "Mother's Day",
    'shop.occasion.valentinesDay': "Valentine's Day",

    // Wishlist
    'wishlist.title': 'Wishlist',
    'wishlist.empty': 'Your wishlist is empty',
    'wishlist.removeItem': 'Remove Item',
    'wishlist.clearWishlist': 'Clear Wishlist',
    'wishlist.description': 'Save items you love by clicking the heart icon',
    'wishlist.continueShopping': 'Continue Shopping',

    // Cart
    'cart.title': 'Cart',
    'cart.empty': 'Your cart is empty',
    'cart.description': 'Add some beautiful flowers to your cart',
    'cart.addExtras': 'Complete Your Order',
    'cart.subtotal': 'Subtotal',
    'cart.tax': 'Tax',
    'cart.shipping': 'Shipping',
    'cart.total': 'Total',
    'cart.proceedToCheckout': 'Proceed to Checkout',
    'cart.continueShopping': 'Continue Shopping',
    'cart.removeItem': 'Remove Item',
    'cart.clearCart': 'Clear Cart',
    'cart.checkout': 'Checkout',
    'cart.viewCart': 'View Cart Details',
    
    // Cart Toast Messages
    'cart.toast.addedToCart': 'Added to Cart',
    'cart.toast.addedToCartDesc': 'Item added to cart. View your cart to manage items.',
    'cart.toast.information': 'Information',
    'cart.toast.alreadyInCart': 'Item already in cart. Check your cart for updated quantity.',
    'cart.toast.removedFromCart': 'Removed from Cart',
    'cart.toast.removedFromCartDesc': 'Item has been removed from your cart.',
    'cart.toast.cartUpdated': 'Cart Updated',
    'cart.toast.quantityUpdated': 'Updated quantity to',
    'cart.toast.cartCleared': 'Cart Cleared',
    'cart.toast.cartClearedDesc': 'All items have been removed from your cart.',
    'cart.toast.stockLimitReached': 'Stock Limit Reached',
    'cart.toast.maxStockAvailable': 'Maximum available',
    
    // Discount codes
    'discount.label': 'Discount Code',
    'discount.placeholder': 'Enter code',
    'discount.apply': 'Apply',
    'discount.remove': 'Remove',
    'discount.applied': 'Discount applied!',
    'discount.saved': 'You saved',
    'discount.invalid': 'Invalid discount code',
    'discount.expired': 'Discount code expired',
    'discount.removed': 'Discount removed',
    'discount.removedDesc': 'Discount code has been removed',
    'discount.validating': 'Validating...',
    'discount.error': 'Failed to validate discount code',
    'discount.discount': 'Discount',
    
    // Wishlist Toast Messages
    'wishlist.toast.addedToWishlist': 'Added to Wishlist',
    'wishlist.toast.addedToWishlistDesc': 'Item has been added to your wishlist.',
    'wishlist.toast.wishlistUpdated': 'Wishlist Updated',
    'wishlist.toast.alreadyInWishlist': 'This item is already in your wishlist',
    'wishlist.toast.removedFromWishlist': 'Removed from Wishlist',
    'wishlist.toast.removedFromWishlistDesc': 'Item has been removed from your wishlist.',

    'cart.checkout.shop': 'Your Cart',
    'cart.checkout.continueShopping': 'Continue Shopping',
    'cart.checkout.checkout': 'Checkout',
    'cart.checkout.size': 'Size',
    'cart.checkout.color': 'Color',
    'cart.checkout.quantity': 'Quantity',
    'cart.checkout.remove': 'Remove',
    'cart.checkout.maximumQuantity': 'Maximum quantity available: ',
    'cart.checkout.proceedToShipping': 'Proceed to Shipping',
    'cart.checkout.proceedToPayment': 'Proceed to Payment',
    'cart.checkout.orderSummary': 'Order Summary',
    'cart.checkout.subtotal': 'Subtotal',
    'cart.checkout.total': 'Total',
    'cart.checkout.shipping': 'Shipping',
    'cart.checkout.tax': 'Tax',

    // Checkout shipping
    'cart.checkout.firstName': 'First Name',
    'cart.checkout.lastName': 'Last Name',
    'cart.checkout.address': 'Address',
    'cart.checkout.apartment': 'Apartment (optional)',
    'cart.checkout.city': 'City',
    'cart.checkout.country': 'Country',
    'cart.checkout.state': 'State',
    'cart.checkout.postalCode': 'Postal Code',
    'cart.checkout.phone': 'Phone',
    'cart.checkout.email': 'Email',
    'cart.checkout.shippingInfo': 'Shipping Information',
    'cart.checkout.shippingInfoText': 'Standard Shipping: Soon as possible (free shipping on orders delivered in Tamaseni or Adjudeni)',
    'cart.checkout.returnToCart': 'Return to Cart',
    'cart.checkout.continueToPayment': 'Continue to Payment',
    'cart.checkout.saveInfo': 'Save Information',
    'cart.checkout.reviewOrderDetails': 'Order Details',
    'cart.checkout.itemsInCart': 'Items in Cart',
    'cart.checkout.resetAllFields': 'Reset All Fields',
    'cart.checkout.saveInfoInfo': 'Your address will not be saved for the next order (for security reasons)',
    'cart.checkout.totalAmount': 'Total',
    'cart.checkout.totalItems': 'Items',
    'cart.checkout.orderSecure': 'All contact data is encrypted to protect you.',
    'cart.checkout.saveInfoText': 'Shipping Information must be saved to be used.',
    'cart.checkout.pleaseSaveShippingInfoFirst': 'Please Save Shipping Info First',
    'cart.checkout.youNeedToFillAndSaveYourShippingDetailsBeforeProceedingToPayment': 'You need to fill and save your shipping details before proceeding to payment.',
    'cart.checkout.shippingInfoSaved': 'Shipping Info Saved',
    'cart.checkout.shippingInfoSavedDesc': 'Your shipping information has been saved successfully.',

    // Billing Information
    'cart.checkout.billingInfo': 'Billing Information',
    'cart.checkout.sameAsShipping': 'Same as shipping address',
    'cart.checkout.billingInfoText': 'Enter the billing address for your invoice',
    'cart.checkout.company': 'Company Name (optional)',
    'cart.checkout.taxId': 'Tax ID / VAT Number (optional)',
    'cart.checkout.billingInfoSaved': 'Billing Info Saved',
    'cart.checkout.billingInfoSavedDesc': 'Your billing information has been saved successfully.',

    // Checkout Payment
    'checkout.payment': 'Payment Method',
    'checkout.paymentInfo': 'Information',
    'checkout.paymentInfoText': 'Your order number will be sent to your email shortly.',
    'checkout.orderSummary': 'Order Summary',
    'checkout.subtotal': 'Subtotal',
    'checkout.total': 'Total',
    'checkout.shipping': 'Shipping',
    'checkout.tax': 'Tax',
    'checkout.creditCardDetails': 'Credit Card Details',
    'checkout.needHelp': 'Need help?',
    'checkout.contactUs': 'Contact Us at',
    'checkout.returnToShipping': 'Return to Shipping',
    'checkout.payNow': 'Pay Now',
    'checkout.allTransactionsSecure': 'All transactions are secure and encrypted.',
    'checkout.securePayment': 'Secure Payment',
    'checkout.cashOnDelivery': 'You can make a cash-on-delivery payment for your purchase!',
    'checkout.yourDeliveryInformation': 'Your Delivery Information',
    'checkout.name': 'Name',
    'checkout.address': 'Address',
    'checkout.postalCode': 'Postal Code',
    'checkout.phone': 'Phone',
    'checkout.email': 'Email',
    'checkout.deliveryInfo': 'Please note: You will pay the delivery person in cash when your order is delivered.',
    'checkout.paymentReference': 'I confirm that I have reviewed the order details and will make the payment in cash upon delivery. After the payment, please contact us on WhatsApp to confirm the payment.',
    'checkout.paymentReferenceText': 'Please confirm that you understand you will pay the delivery person in cash upon delivery.',
    'checkout.processCashOnDelivery': 'Process Cash on Delivery',
    'checkout.bankTransferDetails': 'Bank Transfer Details',
    'checkout.accountName': 'Account Name',
    'checkout.accountNumber': 'Account Number',
    'checkout.bankName': 'Bank Name',
    'checkout.iban': 'IBAN',
    'checkout.swiftBic': 'SWIFT/BIC',

    // Checkout Success
    'checkout.success.title': 'Thank you for your order!',
    'checkout.success.text': 'Your order has been placed and is being processed. You will receive an email confirmation with your order details shortly.',
    'checkout.success.continueShopping': 'Continue Shopping',
    'checkout.success.nextStep': 'What is next?',
    
    // Buttons
    'button.addToCart': 'Add to Cart',
    'button.viewDetails': 'View Details',
    'button.checkout': 'Checkout',
    'button.continueShopping': 'Continue Shopping',
    'button.remove': 'Remove',
    
    // Product
    'product.price': 'Price',
    'product.size': 'Size',
    'product.color': 'Color',
    'product.quantity': 'Quantity',
    'product.description': 'Description',
    'product.reviews': 'Reviews',
    'product.loading': 'Loading product...',
    'product.error': 'Error loading product...',
    'product.notFound': 'Product not found',
    'product.addToCart': 'Add to Cart',
    'product.addToWishlist': 'Add to Wishlist',
    'product.removeFromWishlist': 'Remove from Wishlist',
    'product.buyNow': 'Buy Now',
    'product.inStock': 'In Stock',
    'product.outOfStock': 'Out of Stock',
    'product.unavailableTitle': 'Product Currently Unavailable',
    'product.unavailableMessage': 'This product is currently unavailable. If you really want it, please contact us and we might be able to help somehow.',
    'product.contactUs': 'Contact Us',
    'product.sameDayDelivery': 'Same-day delivery available!',
    'product.careInstructions': 'Flower Care Instructions',
    'product.writeReview': 'Write a Review',
    'product.relatedProducts': 'Related Products',
    'product.newArrival': 'New Arrival',
    'product.featured': 'Featured',
    'product.topRated': 'Top Rated',
    'product.productDetails': 'Product Details',
    'product.youMayAlsoLike': 'You May Also Like',
    'product.viewDetails': 'View Details',
    
    // Product Reviews
    'review.title': 'Review Title',
    'review.name': 'Your Name',
    'review.comment': 'Your Review',
    'review.submitButton': 'Submit Review',
    'review.submitting': 'Submitting...',
    'review.ratingRequired': 'Rating Required',
    'review.ratingRequiredDesc': 'Please select a rating before submitting your review.',
    'review.submitted': 'Review Submitted',
    'review.submittedDesc': 'Thank you for your review!',
    'review.error': 'Failed to submit review',
    'review.errorDesc': 'There was an error submitting your review. Please try again.',
    'review.successMessage': 'Your review has been submitted successfully!',
    'review.verified': 'Verified Purchase',
    'review.helpful': 'Helpful',
    'review.notHelpful': 'Not Helpful',
    'review.noReviews': 'No reviews yet. Be the first to review this product!',
    'review.noReviewsShort': 'No reviews',

    // Contact Page
    'contact.title': 'Contact Us',
    'contact.subtitle': 'Do you have questions or want to order a personalized bouquet? We are here for you!',
    'contact.formTitle': 'Send us a message',
    'contact.nameLabel': 'Name',
    'contact.emailLabel': 'Email',
    'contact.subjectLabel': 'Subject',
    'contact.messageLabel': 'Message',
    'contact.sendButton': 'Send message',
    'contact.sending': 'Sending...',
    'contact.successMessage': 'Your message has been sent successfully! We will contact you soon.',
    'contact.errorMessage': 'An error occurred. Please try again later.',
    'contact.nameRequired': 'Name is required',
    'contact.emailRequired': 'Email is required',
    'contact.emailInvalid': 'Please enter a valid email address',
    'contact.subjectRequired': 'Subject is required',
    'contact.messageRequired': 'Message is required',
    'contact.messageMinLength': 'Message must be at least 10 characters',
    'contact.contactInfo': 'Contact Information',
    'contact.locationTitle': 'Workshop Location',
    'contact.emailTitle': 'Email',
    'contact.phoneTitle': 'Phone',
    'contact.scheduleTitle': 'Schedule',
    'contact.phoneSchedule': 'Monday - Sunday, 08:00 - 22:00',

    // Collections Page
    'collections.title': 'Floral Collections',
    'collections.subtitle': 'Explore our curated collections of beautiful flowers for every occasion',
    'collections.searchPlaceholder': 'Search collections...',
    'collections.featuredOnly': 'Featured Only',
    'collections.loading': 'Loading...',
    'collections.errorLoading': 'Error loading collections. Please try again later.',
    'collections.products': 'Products',
    'collections.viewCollection': 'View Collection',
    'collections.noCollectionsFound': 'No collections found',
    'collections.noCollectionsText': 'Check back soon for new collections',
    'collections.tryAdjusting': 'Try adjusting your search or filters',
    'collections.clearFilters': 'Clear Filters',
    'collections.ctaTitle': 'Can\'t find what you\'re looking for?',
    'collections.ctaSubtitle': 'Browse through a collection or contact us for a personalized bouquet',
    'collections.browseAll': 'Browse All Products',
    'collections.contactUs': 'Contact Us',
    'collections.featured': 'Featured',

    // Collection Detail Page
    'collection.backToCollections': 'Back to Collections',
    'collection.collectionNotFound': 'Collection Not Found',
    'collection.collectionNotFoundText': 'The collection you were looking for was not found or has been removed.',
    'collection.featured': 'Featured',
    'collection.products': 'Products',
    'collection.productsInCollection': 'Products in this Collection',
    'collection.new': 'New',
    'collection.inStock': 'In Stock',
    'collection.outOfStock': 'Out of Stock',
    'collection.noProductsYet': 'No Products Yet',
    'collection.noProductsText': 'This collection doesn\'t have any products at the moment.',
    'collection.browseAll': 'Browse All Products',
    'collection.exploreMore': 'Explore More Collections',
    'collection.exploreMoreText': 'Discover other beautiful floral arrangements',
    'collection.viewAllCollections': 'View All Collections',

    // Events Page
    'events.title': 'Events',
    'events.subtitle': 'Discover our special moments and upcoming events',
    'events.searchPlaceholder': 'Search events...',
    'events.filterAll': 'All Events',
    'events.filterUpcoming': 'Upcoming',
    'events.filterPast': 'Past',
    'events.featured': 'Featured',
    'events.upcoming': 'Upcoming',
    'events.past': 'Past',
    'events.likes': 'Likes',
    'events.shares': 'Shares',
    'events.like': 'Like',
    'events.unlike': 'Unlike',
    'events.share': 'Share',
    'events.loading': 'Loading...',
    'events.noEvents': 'No events found',
    'events.noEventsText': 'Check back soon for new events',
    'events.tryAdjusting': 'Try adjusting your filters',
    'events.linkCopied': 'Link copied to clipboard!',
    'events.waitSession': 'Please wait, loading user session...',
    'events.closeModal': 'Close',
    'events.previousMedia': 'Previous',
    'events.nextMedia': 'Next',
    'events.backToEvents': 'Back to Events',
    'events.notFound': 'Event Not Found',
    'events.notFoundText': 'The event you are looking for was not found or has been removed.',
    'events.failedToLike': 'Failed to like event. Please try again.',
    'events.ofMedia': 'of',

    // Orders Page
    'orders.title': 'Track Your Order',
    'orders.subtitle': 'Enter your tracking number to see order status',
    'orders.trackingNumber': 'Tracking Number -> The tracking number is sent to your email after the order is placed.',
    'orders.trackOrder': 'Track Order',
    'orders.orderDetails': 'Order Details',
    'orders.orderNumber': 'Order Number',
    'orders.placedOn': 'Placed on',
    'orders.status': 'Status',
    'orders.pending': 'Pending',
    'orders.confirmed': 'Confirmed',
    'orders.preparing': 'Preparing',
    'orders.processing': 'Processing',
    'orders.shipped': 'Shipped',
    'orders.outForDelivery': 'Out for Delivery',
    'orders.delivered': 'Delivered',
    'orders.cancelled': 'Cancelled',
    'orders.failedDelivery': 'Failed Delivery',
    'orders.items': 'Items',
    'orders.quantity': 'Quantity',
    'orders.shippingInfo': 'Shipping Information',
    'orders.paymentInfo': 'Payment Information',
    'orders.paymentMethod': 'Payment Method',
    'orders.notFound': 'Order Not Found',
    'orders.notFoundText': 'The order with this tracking number was not found.',
    'orders.enterTracking': 'Please enter a tracking number',

    // Help Page
    'help.title': 'Help Center',
    'help.subtitle': 'Find answers to your questions about our flower shop',
    'help.searchPlaceholder': 'Search for help...',
    'help.noResults': 'No results found. Try different keywords.',
    
    // Cookie Consent
    'cookie.title': 'We Value Your Privacy',
    'cookie.description': 'We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.',
    'cookie.accept': 'Accept All',
    'cookie.decline': 'Decline',
    'cookie.cookiePolicy': 'Cookie Policy',
    'cookie.privacyPolicy': 'Privacy Policy',
    
    // Quick Links
    'help.quickLinks.trackOrder': 'Track Order',
    'help.quickLinks.trackOrderDesc': 'Check your order status',
    'help.quickLinks.contactUs': 'Contact Us',
    'help.quickLinks.contactUsDesc': 'Get in touch with our team',
    'help.quickLinks.browseFlowers': 'Browse Flowers',
    'help.quickLinks.browseFlowersDesc': 'Explore our collection',
    
    // FAQ Title
    'help.faq.title': 'Frequently Asked Questions',
    
    // Ordering
    'help.ordering.title': 'Ordering',
    'help.ordering.howToOrder': 'How do I place an order?',
    'help.ordering.howToOrderAnswer': 'To place an order:\n1. Browse our shop and select your desired flowers\n2. Click "Add to Cart"\n3. Review your cart and click "Proceed to Checkout"\n4. Fill in your shipping information\n5. Choose your payment method and complete the purchase',
    'help.ordering.modifyOrder': 'Can I modify my order after placing it?',
    'help.ordering.modifyOrderAnswer': 'You can modify your order within 1 hour of placing it. Please contact us immediately at 0769141250 or via email. After this time, orders are sent to our florists and cannot be changed.',
    'help.ordering.cancelOrder': 'How do I cancel my order?',
    'help.ordering.cancelOrderAnswer': 'Orders can be cancelled within 1 hour of placement. Contact us as soon as possible. Refunds are processed within 5-7 business days.',
    'help.ordering.trackOrder': 'How can I track my order?',
    'help.ordering.trackOrderAnswer': 'You will receive a tracking number via email after your order is confirmed. Visit our "Track Order" page and enter your tracking number to see real-time updates.',
    
    // Delivery
    'help.delivery.title': 'Delivery',
    'help.delivery.deliveryTime': 'What are your delivery times?',
    'help.delivery.deliveryTimeAnswer': 'We offer three delivery time slots:\n- Morning: 9 AM - 12 PM\n- Afternoon: 12 PM - 5 PM\n- Evening: 5 PM - 8 PM\n',
    'help.delivery.sameDayDelivery': 'Do you offer same-day delivery?',
    'help.delivery.sameDayDeliveryAnswer': 'Yes! Orders placed before 8 PM can be delivered the same day in major cities. Same-day delivery is available for selected products marked with "Same-day delivery available!"',
    'help.delivery.deliveryAreas': 'Where do you deliver?',
    'help.delivery.deliveryAreasAnswer': 'We deliver throughout Neamț County. Delivery times may vary based on your location.',
    'help.delivery.notHome': 'What if the recipient is not home?',
    'help.delivery.notHomeAnswer': 'Our delivery team will contact the recipient to arrange a convenient delivery time. If unable to reach them, we will contact you (the sender) for further instructions.',
    
    // Payment
    'help.payment.title': 'Payment',
    'help.payment.paymentMethods': 'What payment methods do you accept?',
    'help.payment.paymentMethodsAnswer': 'We accept:\n- Credit/Debit Cards (Visa, Mastercard)\n- Online payment via euPlatesc - currently not available\n- Cash on Delivery\n- Bank Transfer',
    'help.payment.securePayment': 'Is my payment information secure?',
    'help.payment.securePaymentAnswer': 'Yes! All online payments are processed through secure, encrypted connections. We use euPlatesc for card payments, which is PCI DSS compliant. We never store your complete card details.',
    'help.payment.cashOnDelivery': 'How does Cash on Delivery work?',
    'help.payment.cashOnDeliveryAnswer': 'With Cash on Delivery, you pay the delivery person in cash when your order arrives. This option is available for all orders. Please have exact change ready if possible.',
    
    // Flowers
    'help.flowers.title': 'Flower Care',
    'help.flowers.flowerCare': 'How do I care for my flowers?',
    'help.flowers.flowerCareAnswer': 'General care tips:\n- Change water daily\n- Trim stems at a 45° angle every 2-3 days\n- Remove dead leaves\n- Keep away from direct sunlight\n- Maintain cool room temperature\n',
    'help.flowers.howLong': 'How long will my flowers last?',
    'help.flowers.howLongAnswer': 'With proper care, most bouquets last 7-10 days. Some flowers like sunflowers can last up to 12 days, while tulips typically last 5-7 days. Each product page includes expected lifespan information.',
    'help.flowers.customBouquet': 'Can I create a custom bouquet?',
    'help.flowers.customBouquetAnswer': 'Yes! Contact us via phone (0769141250) or email (laurasimona97@yahoo.com or simonabuzau2@gmail.com) with your preferences for colors, flower types, and occasion. Our florists will create a personalized arrangement for you.',
    'help.flowers.freshness': 'How do you ensure flower freshness?',
    'help.flowers.freshnessAnswer': 'We source flowers daily from trusted local and international growers. Each bouquet is inspected for quality before delivery. We offer a freshness guarantee - contact us within 24 hours if you\'re not satisfied.',
    
    // Products
    'help.products.title': 'Products',
    'help.products.outOfStock': 'What if my desired flower is out of stock?',
    'help.products.outOfStockAnswer': 'Flower availability varies by season. If a product is out of stock, we can suggest similar alternatives or notify you when it becomes available. Contact us for recommendations.',
    'help.products.addOns': 'Can I add extras to my order?',
    'help.products.addOnsAnswer': 'Yes! You can add a personalized message card to any order. Some products also offer vase options and other add-ons. These options appear during checkout.',
    
    // Account
    'help.account.title': 'Account & Wishlist',
    'help.account.wishlist': 'How does the Wishlist work?',
    'help.account.wishlistAnswer': 'Click the heart icon on any product to add it to your Wishlist. Your wishlist is saved in your browser, making it easy to find and order your favorite flowers later.',
    'help.account.orderHistory': 'Can I reorder from previous purchases?',
    'help.account.orderHistoryAnswer': 'You can track your orders using the tracking number sent to your email. To reorder, simply find the product in our shop and add it to your cart again.',
    
    // Still Need Help
    'help.stillNeedHelp.title': 'Still Need Help?',
    'help.stillNeedHelp.subtitle': 'Our customer service team is here to assist you',
    'help.contact.phone': 'Phone',
    'help.contact.email': 'Email',
    'help.contact.message': 'Send Message',
    'help.contact.sendMessage': 'Contact Us',

    // Checkout cancel
    'checkout.cancel.title': 'Payment Failed',
    'checkout.cancel.paymentFailed': 'Payment failed. Please try again.',
    'checkout.cancel.paymentCancelled': 'Payment cancelled.',
    'checkout.cancel.defaultError': 'An error occurred with the payment.',
    'checkout.cancel.whatHappened': 'What happened?',
    'checkout.cancel.noCharge': 'You were not charged',
    'checkout.cancel.noOrder': 'The order was not placed',
    'checkout.cancel.cartSaved': 'Your cart is safe',
    'checkout.cancel.commonIssues': 'Common issues:',
    'checkout.cancel.insufficientFunds': 'Insufficient funds on card',
    'checkout.cancel.incorrectDetails': 'Incorrect card details',
    'checkout.cancel.cardNotActivated': 'Card not activated for online payments',
    'checkout.cancel.connectionIssue': 'Connection issues',
    'checkout.cancel.autoRedirect': 'You will be automatically redirected in',
    'checkout.cancel.secundă': 'second',
    'checkout.cancel.secunde': 'seconds',
    'checkout.cancel.tryAgain': 'Try again',
    'checkout.cancel.backToCart': 'Back to Cart',
    'checkout.cancel.contactSupport': 'Contact Support',
  },
  ro: {

    // Navigation
    'nav.home': 'Acasă',
    'nav.shop': 'Magazin',
    'nav.extras': 'Extra',
    'nav.contact': 'Contact',
    'nav.collections': 'Colecții',
    'nav.events': 'Evenimente',
    'nav.blog': 'Blog',
    'nav.help': 'Ajutor',
    'nav.trackOrder': 'Urmărește Comanda',

    // Footer
    'footer.tagline': 'Flori proaspete, alese și legate manual în fiecare zi, livrate cu grijă în tot județul Neamț.',
    'footer.navigation': 'Navigare',
    'footer.contact': 'Contact',
    'footer.rights': 'Toate drepturile rezervate.',
    'footer.terms': 'Termeni',
    'footer.cookiePolicy': 'Politica de cookies',
    'footer.gdpr': 'GDPR',

    // Extras page
    'extras.title': 'Extra & Cadouri Suplimentare',
    'extras.subtitle': 'Completează cadoul tău cu articole speciale',
    'extras.categories': 'Categorii',
    'extras.allCategories': 'Toate Categoriile',
    'extras.filterBy': 'Filtrează după',
    'extras.clearFilters': 'Șterge Filtrele',
    'extras.noExtras': 'Nu s-au găsit articole',
    'extras.addToCart': 'Adaugă în Coș',
    'extras.viewDetails': 'Vezi Detalii',
    
    // Extra categories
    'extras.category.chocolates': 'Ciocolată',
    'extras.category.vases': 'Vaze',
    'extras.category.cards': 'Felicitări',
    'extras.category.toys': 'Jucării',
    'extras.category.balloons': 'Baloane',
    'extras.category.wines': 'Vinuri',
    'extras.category.other': 'Altele',
    
    // Extra sizes
    'extras.size.small': 'Mic',
    'extras.size.medium': 'Mediu',
    'extras.size.large': 'Mare',
    
    // Homepage
    'homepage.heroTitle': 'Bine ai venit la',
    'homepage.heroSubtitle': 'Buchetul Simonei Poezia Florilor',
    'homepage.banner': 'Descoperă Flori Proaspete pentru Orice Ocazie',
    'homepage.shopNow': 'Cumpără Acum',
    'homepage.exploreColl': 'Sau explorează colecțiile noastre',
    'homepage.themeSwitch': 'Schimbă culoarea fundalului în selectorul de temă',

    // Shop page
    'shop.title': 'Descoperă Florăria Noastră',
    'shop.subtitle': 'Găsește buchetul perfect pentru orice ocazie din selecția noastră de flori proaspete și aranjamente florale',
    'shop.search': 'Caută produse',
    'shop.filterBy': 'Filtrează după',
    'shop.allCategories': 'Toate Categoriile',
    'shop.clearFilters': 'Șterge Filtrele',
    'shop.noProducts': 'Nu s-au găsit produse',
    'shop.tryDifferentSearch': 'Încearcă să ajustezi căutarea sau criteriile de filtrare',
    'shop.showFilters': 'Afișează Filtrele',
    'shop.hideFilters': 'Ascunde Filtrele',
    'shop.mobileFilters': 'Filtre',
    'shop.categories': 'Categorii',
    'shop.colors': 'Culori',
    'shop.occasions': 'Ocazii',
    'shop.sortBy': 'Sortează după',
    'shop.sameDayDelivery': 'Livrare în aceeași zi',
    'shop.clearAll': 'Șterge Toate',
    'shop.loading': 'Se încarcă produsele...',
    'shop.error': 'Eroare la încărcarea produselor. Te rugăm să încerci din nou.',
    
    // Opțiuni de sortare
    'shop.sort.featured': 'Recomandate',
    'shop.sort.priceAsc': 'Preț: Crescător',
    'shop.sort.priceDesc': 'Preț: Descrescător',
    'shop.sort.newest': 'Cele mai noi',
    'shop.sort.rating': 'Cel mai bine cotate',
    
    // Culori
    'shop.color.rosu': 'Roșu',
    'shop.color.roz': 'Roz',
    'shop.color.alb': 'Alb',
    'shop.color.galben': 'Galben',
    'shop.color.mov': 'Mov',
    'shop.color.portocaliu': 'Portocaliu',
    'shop.color.albastru': 'Albastru',
    'shop.color.mixt': 'Mixt',
    'shop.color.pastel': 'Pastel',
    'shop.color.negru': 'Negru',
    
    // Ocazii
    'shop.occasion.birthday': 'Zi de naștere',
    'shop.occasion.anniversary': 'Aniversare',
    'shop.occasion.wedding': 'Nuntă',
    'shop.occasion.funeral': 'Funeralii',
    'shop.occasion.romantic': 'Romantic',
    'shop.occasion.congratulations': 'Felicitări',
    'shop.occasion.getWell': 'Însănătoșire',
    'shop.occasion.thankYou': 'Mulțumire',
    'shop.occasion.justBecause': 'Fără motiv',
    'shop.occasion.mothersDay': 'Ziua Mamei',
    'shop.occasion.valentinesDay': 'Ziua Îndrăgostiților',

    // Lista de dorinte
    'wishlist.title': 'Lista de dorinte',
    'wishlist.empty': 'Lista de dorinte este goala',
    'wishlist.removeItem': 'Șterge din lista de dorinte',
    'wishlist.clearWishlist': 'Șterge lista de dorinte',
    'wishlist.description': 'Salvează produsele pe care le-ai ales în lista de dorinte',
    'wishlist.continueShopping': 'Continuă Cumpărăturile',

    // Cos de cumparaturi
    'cart.title': 'Coșul Tău',
    'cart.empty': 'Coșul Tău este gol',
    'cart.description': 'Adaugă niște flori frumoase în coș',
    'cart.addExtras': 'Completează Comanda',
    'cart.subtotal': 'Subtotal',
    'cart.tax': 'Tax',
    'cart.shipping': 'Shipping',
    'cart.total': 'Total',
    'cart.proceedToCheckout': 'Continuă Cumpărăturile',
    'cart.continueShopping': 'Continuă Cumpărăturile',
    'cart.removeItem': 'Șterge din coș',
    'cart.clearCart': 'Șterge coșul',
    'cart.checkout': 'Checkout',
    'cart.extra': 'Extra',
    'cart.viewCart': 'Vezi detalii coș',
    
    // Cart Toast Messages
    'cart.toast.addedToCart': 'Adăugat în Coș',
    'cart.toast.addedToCartDesc': 'Produs adăugat în coș. Vezi coșul pentru a gestiona produsele.',
    'cart.toast.information': 'Informație',
    'cart.toast.alreadyInCart': 'Produsul este deja în coș. Verifică coșul pentru cantitate actualizată.',
    'cart.toast.removedFromCart': 'Șters din Coș',
    'cart.toast.removedFromCartDesc': 'Produsul a fost șters din coș.',
    'cart.toast.cartUpdated': 'Coș Actualizat',
    'cart.toast.quantityUpdated': 'Cantitate actualizată la',
    'cart.toast.cartCleared': 'Coș Golit',
    'cart.toast.cartClearedDesc': 'Toate produsele au fost șterse din coș.',
    'cart.toast.stockLimitReached': 'Limită Stoc Atinsă',
    'cart.toast.maxStockAvailable': 'Maxim disponibil',
    
    // Discount codes
    'discount.label': 'Cod de reducere',
    'discount.placeholder': 'Introdu codul',
    'discount.apply': 'Aplică',
    'discount.remove': 'Elimină',
    'discount.applied': 'Reducere aplicată!',
    'discount.saved': 'Ai economisit',
    'discount.invalid': 'Cod invalid',
    'discount.expired': 'Cod expirat',
    'discount.removed': 'Reducere eliminată',
    'discount.removedDesc': 'Codul de reducere a fost eliminat',
    'discount.validating': 'Validare...',
    'discount.error': 'Eroare la validarea codului',
    'discount.discount': 'Reducere',
    
    // Wishlist Toast Messages
    'wishlist.toast.addedToWishlist': 'Adăugat la Favorite',
    'wishlist.toast.addedToWishlistDesc': 'Produsul a fost adăugat la favorite.',
    'wishlist.toast.wishlistUpdated': 'Favorite Actualizate',
    'wishlist.toast.alreadyInWishlist': 'Acest produs este deja în lista de favorite',
    'wishlist.toast.removedFromWishlist': 'Șters din Favorite',
    'wishlist.toast.removedFromWishlistDesc': 'Produsul a fost șters din favorite.',

    'cart.checkout.orderSummary': 'Sumarul Comandă',
    'cart.checkout.subtotal': 'Subtotal',
    'cart.checkout.total': 'Total',
    'cart.checkout.shipping': 'Shipping',
    'cart.checkout.tax': 'Tax',
    'cart.checkout.proceedToPayment': 'Spre Plata',
    'cart.checkout.proceedToShipping': 'Continuă Cumpărăturile',
    'cart.checkout.size': 'Mărime',
    'cart.checkout.color': 'Culoare',
    'cart.checkout.quantity': 'Cantitate',
    'cart.checkout.remove': 'Șterge',
    'cart.checkout.maximumQuantity': 'Cantitatea maxima disponibila este: ',

    // Checkout shipping
    'cart.checkout.firstName': 'Nume',
    'cart.checkout.lastName': 'Prenume',
    'cart.checkout.address': 'Adresă',
    'cart.checkout.apartment': 'Apartament (opțional)',
    'cart.checkout.city': 'Oras',
    'cart.checkout.country': 'Țară',
    'cart.checkout.state': 'Judet',
    'cart.checkout.postalCode': 'Cod Poștal',
    'cart.checkout.phone': 'Telefon',
    'cart.checkout.email': 'Email',
    'cart.checkout.shippingInfo': 'Informații de Livrare',
    'cart.checkout.shippingInfoText': 'Livrare standard: În cel mai scurt timp posibil (livrare gratuită pe comenzi livrate în Tamaseni sau Adjudeni)',
    'cart.checkout.returnToCart': 'Întoarce-te la Coș',
    'cart.checkout.continueToPayment': 'Continuă Cumpărăturile',
    'cart.checkout.saveInfo': 'Salvează Informațiile',
    'cart.checkout.reviewOrderDetails': 'Detalii Comandă',
    'cart.checkout.itemsInCart': 'Articole din cos',
    'cart.checkout.resetAllFields': 'Reseteaza toate campurile',
    'cart.checkout.saveInfoInfo': 'Adresa ta nu va fi salvata pentru urmatoarea comanda (pentru motive de securitate)',
    'cart.checkout.totalAmount': 'Total',
    'cart.checkout.totalItems': 'Articole',
    'cart.checkout.orderSecure': 'Toate datele de contact sunt criptate pentru a te proteja.',
    'cart.checkout.saveInfoText': 'Informațiile de Livrare trebuie să fie salvate pentru a putea fi folosite.',
    'cart.checkout.pleaseSaveShippingInfoFirst': 'Te Rugăm Salvează Informațiile de Livrare',
    'cart.checkout.youNeedToFillAndSaveYourShippingDetailsBeforeProceedingToPayment': 'Trebuie să completezi și să salvezi detaliile de livrare înainte de a proceda la plată.',
    'cart.checkout.shippingInfoSaved': 'Informații de Livrare Salvate',
    'cart.checkout.shippingInfoSavedDesc': 'Informațiile tale de livrare au fost salvate cu succes.',

    // Billing Information
    'cart.checkout.billingInfo': 'Informații de Facturare',
    'cart.checkout.sameAsShipping': 'Aceeași ca adresa de livrare',
    'cart.checkout.billingInfoText': 'Introduceți adresa de facturare pentru factura dumneavoastră',
    'cart.checkout.company': 'Nume Firmă (opțional)',
    'cart.checkout.taxId': 'CUI / Cod Fiscal (opțional)',
    'cart.checkout.billingInfoSaved': 'Informații de Facturare Salvate',
    'cart.checkout.billingInfoSavedDesc': 'Informațiile tale de facturare au fost salvate cu succes.',

    // Checkout Payment
    'checkout.euplatescInfo': 'Voi fi redirecționat la pagina de plată a euPlatesc.ro',
    'checkout.euplatescSecure': 'Informațiile tale de plată sunt procesate în mod securizat de euPlatesc.ro',
    'checkout.proceedToPayment': 'Spre plată',
    'checkout.payment': 'Metoda de Plata',
    'checkout.paymentInfo': 'Informații',
    'checkout.paymentInfoText': 'Numarul comenzii tale va fi trimis pe emailul tau curand. Alaturi de detaliile comenzii tale.',
    'checkout.orderSummary': 'Sumarul Comandă',
    'checkout.subtotal': 'Subtotal',
    'checkout.total': 'Total',
    'checkout.shipping': 'Livrare',
    'checkout.tax': 'Tax',
    'checkout.creditCardDetails': 'Detalii Card',
    'checkout.needHelp': 'Ai nevoie de ajutor?',
    'checkout.contactUs': 'Contacteaza-ne la',
    'checkout.returnToShipping': 'Intoarce-te la Livrare',
    'checkout.payNow': 'Plata',
    'checkout.allTransactionsSecure': 'Toate tranzactiile sunt securizate si criptate.',
    'checkout.securePayment': 'Plata securizata',
    'checkout.cashOnDelivery': 'Poți plăti livratorului când comanda este livrată!',
    'checkout.yourDeliveryInformation': 'Informațiile de Livrare',
    'checkout.name': 'Nume',
    'checkout.address': 'Adresa',
    'checkout.postalCode': 'Cod Poștal',
    'checkout.phone': 'Telefon',
    'checkout.email': 'Email',
    'checkout.deliveryInfo': 'Notă: Voi plăti livratorului când comanda este livrată.',
    'checkout.paymentReference': 'Confirmă că ai revizuit detaliile comenzii și că vei plăti livratorului când comanda este livrată.',
    'checkout.paymentReferenceBankTransfer': 'Confirmă că ai revizuit detaliile comenzii și că vei plăti prin transfer bancar dupa plasarea comenzii pentru a putea fi procesata de noi.',
    'checkout.paymentReferenceTextBankTransfer': 'Confirmă că înțelegi că vei plăti prin transfer bancar dupa plasarea comenzii pentru a putea fi procesata de noi. Dupa plata, te rugam sa ne contactezi pe WhatsApp pentru a confirma plata.',
    'checkout.paymentReferenceText': 'Confirmă că înțelegi că vei plăti în efect livratorului când comanda este livrată.',
    'checkout.processCashOnDelivery': 'Procesează Plata',
    'checkout.bankTransferDetails': 'Detalii Transfer Bancar',
    'checkout.accountName': 'Nume Cont',
    'checkout.bankName': 'Nume Banca',
    'checkout.iban': 'IBAN',
    'checkout.swiftBic': 'SWIFT/BIC',
    'checkout.processBankTransfer': 'Procesează Plata',
    
    // Checkout Success
    'checkout.success.title': 'Mulțumim pentru comanda ta!',
    'checkout.success.text': 'Comanda ta a fost plasată, te contactam noi! Vei primi un email cu detaliile comenzii.',
    'checkout.success.continueShopping': 'Continuă Cumpărăturile',
    'checkout.success.nextStep': 'Ce urmează?',

    // Buttons
    'button.addToCart': 'Adaugă în Coș',
    'button.viewDetails': 'Vezi Detalii',
    'button.checkout': 'Finalizează Comanda',
    'button.continueShopping': 'Continuă Cumpărăturile',
    'button.remove': 'Șterge',
    
    // Product
    'product.price': 'Preț',
    'product.size': 'Mărime',
    'product.color': 'Culoare',
    'product.quantity': 'Cantitate',
    'product.description': 'Descriere',
    'product.reviews': 'Recenzii',
    'product.loading': 'Se încarcă produsul...',
    'product.error': 'Eroare la încărcarea produsului...',
    'product.notFound': 'Produs negăsit',
    'product.addToCart': 'Adaugă în Coș',
    'product.addToWishlist': 'Adaugă la Favorite',
    'product.removeFromWishlist': 'Șterge de la Favorite',
    'product.buyNow': 'Cumpără Acum',
    'product.inStock': 'În Stoc',
    'product.outOfStock': 'Stoc Epuizat',
    'product.unavailableTitle': 'Produs Momentan Indisponibil',
    'product.unavailableMessage': 'Momentan produsul este indisponibil. Dacă doriți neapărat, contactați-ne și poate rezolvăm cumva.',
    'product.contactUs': 'Contactează-ne',
    'product.sameDayDelivery': 'Livrare în aceeași zi disponibilă!',
    'product.careInstructions': 'Instrucțiuni de Îngrijire',
    'product.writeReview': 'Scrie o Recenzie',
    'product.relatedProducts': 'Produse Asemănătoare',
    'product.newArrival': 'Nou Sosit',
    'product.featured': 'Recomandat',
    'product.topRated': 'Cel Mai Bine Cotat',
    'product.productDetails': 'Detalii Produs',
    'product.youMayAlsoLike': 'S-ar putea să-ți placă și',
    'product.viewDetails': 'Vezi Detalii',
    
    // Product Reviews
    'review.title': 'Titlu Recenzie',
    'review.name': 'Numele Tău',
    'review.comment': 'Recenzia Ta',
    'review.submitButton': 'Trimite Recenzia',
    'review.submitting': 'Se trimite...',
    'review.ratingRequired': 'Evaluare Necesară',
    'review.ratingRequiredDesc': 'Te rugăm să selectezi o evaluare înainte de a trimite recenzia.',
    'review.submitted': 'Recenzie Trimisă',
    'review.submittedDesc': 'Mulțumim pentru recenzia ta!',
    'review.error': 'Eroare la trimiterea recenziei',
    'review.errorDesc': 'A apărut o eroare la trimiterea recenziei. Te rugăm să încerci din nou.',
    'review.successMessage': 'Recenzia ta a fost trimisă cu succes!',
    'review.verified': 'Cumpărare Verificată',
    'review.helpful': 'Util',
    'review.notHelpful': 'Nu este util',
    'review.noReviews': 'Încă nu există recenzii. Fii primul care scrie o recenzie!',
    'review.noReviewsShort': 'Fără recenzii',

    // Contact Page
    'contact.title': 'Contactează-ne',
    'contact.subtitle': 'Ai întrebări sau dorești să comanzi un buchet personalizat? Suntem aici pentru tine!',
    'contact.formTitle': 'Trimite-ne un mesaj',
    'contact.nameLabel': 'Nume',
    'contact.emailLabel': 'Email',
    'contact.subjectLabel': 'Subiect',
    'contact.messageLabel': 'Mesaj',
    'contact.sendButton': 'Trimite mesaj',
    'contact.sending': 'Se trimite...',
    'contact.successMessage': 'Mesajul dvs. a fost trimis cu succes! Vă vom contacta în curând.',
    'contact.errorMessage': 'A apărut o eroare. Vă rugăm să încercați din nou mai târziu.',
    'contact.nameRequired': 'Numele este obligatoriu',
    'contact.emailRequired': 'Email-ul este obligatoriu',
    'contact.emailInvalid': 'Vă rugăm să introduceți o adresă de email validă',
    'contact.subjectRequired': 'Subiectul este obligatoriu',
    'contact.messageRequired': 'Mesajul este obligatoriu',
    'contact.messageMinLength': 'Mesajul trebuie să aibă cel puțin 10 caractere',
    'contact.contactInfo': 'Informații de contact',
    'contact.locationTitle': 'Locația Atelierului',
    'contact.emailTitle': 'Email',
    'contact.phoneTitle': 'Telefon',
    'contact.scheduleTitle': 'Program',
    'contact.phoneSchedule': 'Luni - Duminică, 08:00 - 22:00',

    // Collections Page
    'collections.title': 'Colecții Florale',
    'collections.subtitle': 'Explorează colecțiile noastre curate de flori frumoase pentru fiecare ocazie',
    'collections.searchPlaceholder': 'Caută colecții...',
    'collections.featuredOnly': 'Doar Recomandate',
    'collections.loading': 'Se încarcă...',
    'collections.errorLoading': 'Eroare la încărcarea colecțiilor. Vă rugăm să încercați din nou mai târziu.',
    'collections.products': 'Produse',
    'collections.viewCollection': 'Vezi Colecția',
    'collections.noCollectionsFound': 'Nu s-au găsit colecții',
    'collections.noCollectionsText': 'Revino în curând pentru colecții noi',
    'collections.tryAdjusting': 'Încearcă să ajustezi căutarea sau filtrele',
    'collections.clearFilters': 'Șterge Filtrele',
    'collections.ctaTitle': 'Nu găsești ce cauți?',
    'collections.ctaSubtitle': 'Navighează printr-o colecție sau contactează-ne pentru un buchet personalizat',
    'collections.browseAll': 'Vezi Toate Produsele',
    'collections.contactUs': 'Contactează-ne',
    'collections.featured': 'Recomandat',

    // Collection Detail Page
    'collection.backToCollections': 'Înapoi la Colecții',
    'collection.collectionNotFound': 'Colecție Negăsită',
    'collection.collectionNotFoundText': 'Colecția pe care o căutai nu a fost găsită sau a fost eliminată.',
    'collection.featured': 'Recomandat',
    'collection.products': 'Produse',
    'collection.productsInCollection': 'Produse în această Colecție',
    'collection.new': 'Nou',
    'collection.inStock': 'În Stoc',
    'collection.outOfStock': 'Stoc Epuizat',
    'collection.noProductsYet': 'Încă Nu Sunt Produse',
    'collection.noProductsText': 'Această colecție nu are produse momentan.',
    'collection.browseAll': 'Vezi Toate Produsele',
    'collection.exploreMore': 'Explorează Mai Multe Colecții',
    'collection.exploreMoreText': 'Descoperă alte aranjamente florale frumoase',
    'collection.viewAllCollections': 'Vezi Toate Colecțiile',

    // Events Page
    'events.title': 'Evenimente',
    'events.subtitle': 'Descoperiți momentele noastre speciale și evenimentele viitoare',
    'events.searchPlaceholder': 'Caută evenimente...',
    'events.filterAll': 'Toate Evenimentele',
    'events.filterUpcoming': 'Viitoare',
    'events.filterPast': 'Trecute',
    'events.featured': 'Recomandat',
    'events.upcoming': 'Viitor',
    'events.past': 'Trecut',
    'events.likes': 'Aprecieri',
    'events.shares': 'Distribuiri',
    'events.like': 'Apreciază',
    'events.unlike': 'Nu mai apreciază',
    'events.share': 'Distribuie',
    'events.loading': 'Se încarcă...',
    'events.noEvents': 'Nu există evenimente',
    'events.noEventsText': 'Revino curând pentru evenimente noi',
    'events.tryAdjusting': 'Încearcă să modifici filtrele',
    'events.linkCopied': 'Link copiat în clipboard!',
    'events.waitSession': 'Te rugăm să aștepți, se încarcă sesiunea...',
    'events.closeModal': 'Închide',
    'events.previousMedia': 'Anterior',
    'events.nextMedia': 'Următor',
    'events.backToEvents': 'Înapoi la Evenimente',
    'events.notFound': 'Eveniment Negăsit',
    'events.notFoundText': 'Evenimentul pe care îl cauți nu a fost găsit sau a fost eliminat.',
    'events.failedToLike': 'Nu s-a putut aprecia evenimentul. Te rugăm să încerci din nou.',
    'events.ofMedia': 'din',

    // Orders Page
    'orders.title': 'Urmărește Comanda',
    'orders.subtitle': 'Introdu numărul de urmărire pentru a vedea statusul comenzii',
    'orders.trackingNumber': 'Număr de Urmărire -> Numărul de urmărire este trimis pe emailul tău după plasarea comenzii.',
    'orders.trackOrder': 'Urmărește Comanda',
    'orders.orderDetails': 'Detalii Comandă',
    'orders.orderNumber': 'Număr Comandă',
    'orders.placedOn': 'Plasată pe',
    'orders.status': 'Status',
    'orders.pending': 'În Așteptare',
    'orders.confirmed': 'Confirmată',
    'orders.preparing': 'În Pregătire',
    'orders.processing': 'În Procesare',
    'orders.shipped': 'Expediată',
    'orders.outForDelivery': 'În Livrare',
    'orders.delivered': 'Livrată',
    'orders.cancelled': 'Anulată',
    'orders.failedDelivery': 'Livrare Eșuată',
    'orders.items': 'Articole',
    'orders.quantity': 'Cantitate',
    'orders.shippingInfo': 'Informații de Livrare',
    'orders.paymentInfo': 'Informații de Plată',
    'orders.paymentMethod': 'Metodă de Plată',
    'orders.notFound': 'Comandă Negăsită',
    'orders.notFoundText': 'Comanda cu acest număr de urmărire nu a fost găsită.',
    'orders.enterTracking': 'Vă rugăm să introduceți un număr de urmărire',

    // Help Page
    'help.title': 'Centru de Ajutor',
    'help.subtitle': 'Găsește răspunsuri la întrebările tale despre florăria noastră',
    'help.searchPlaceholder': 'Caută ajutor...',
    'help.noResults': 'Nu s-au găsit rezultate. Încearcă alte cuvinte cheie.',
    
    // Cookie Consent
    'cookie.title': 'Respectăm Confidențialitatea Ta',
    'cookie.description': 'Folosim cookie-uri pentru a îmbunătăți experiența ta de navigare, pentru a oferi conținut personalizat și pentru a analiza traficul. Apăsând "Acceptă Toate", consimți la utilizarea cookie-urilor.',
    'cookie.accept': 'Acceptă Toate',
    'cookie.decline': 'Refuză',
    'cookie.cookiePolicy': 'Politica Cookie-uri',
    'cookie.privacyPolicy': 'Politica de Confidențialitate',
    
    // Quick Links
    'help.quickLinks.trackOrder': 'Urmărește Comanda',
    'help.quickLinks.trackOrderDesc': 'Verifică statusul comenzii tale',
    'help.quickLinks.contactUs': 'Contactează-ne',
    'help.quickLinks.contactUsDesc': 'Ia legătura cu echipa noastră',
    'help.quickLinks.browseFlowers': 'Explorează Florile',
    'help.quickLinks.browseFlowersDesc': 'Descoperă colecția noastră',
    
    // FAQ Title
    'help.faq.title': 'Întrebări Frecvente',
    
    // Ordering
    'help.ordering.title': 'Comenzi',
    'help.ordering.howToOrder': 'Cum plasez o comandă?',
    'help.ordering.howToOrderAnswer': 'Pentru a plasa o comandă:\n1. Navighează prin magazinul nostru și selectează florile dorite\n2. Apasă "Adaugă în Coș"\n3. Revizuiește coșul și apasă "Continuă la Checkout"\n4. Completează informațiile de livrare\n5. Alege metoda de plată și finalizează achiziția',
    'help.ordering.modifyOrder': 'Pot modifica comanda după plasare?',
    'help.ordering.modifyOrderAnswer': 'Poți modifica comanda în termen de 1 oră de la plasare. Te rugăm să ne contactezi imediat la 0769141250 sau prin email. După acest timp, comenzile sunt trimise la florarii și nu pot fi modificate.',
    'help.ordering.cancelOrder': 'Cum anulez comanda?',
    'help.ordering.cancelOrderAnswer': 'Comenzile pot fi anulate în termen de 1 oră de la plasare. Contactează-ne cât mai curând. Rambursările sunt procesate în 5-7 zile lucrătoare.',
    'help.ordering.trackOrder': 'Cum pot urmări comanda?',
    'help.ordering.trackOrderAnswer': 'Vei primi un număr de urmărire prin email după confirmarea comenzii. Vizitează pagina "Urmărește Comanda" și introdu numărul de urmărire pentru a vedea actualizări în timp real.',
    
    // Delivery
    'help.delivery.title': 'Livrare',
    'help.delivery.deliveryTime': 'Care sunt intervalele de livrare?',
    'help.delivery.deliveryTimeAnswer': 'Oferim trei intervale de livrare:\n- Dimineață: 9:00 - 12:00\n- După-amiază: 12:00 - 17:00\n- Seară: 17:00 - 20:00\n',
    'help.delivery.sameDayDelivery': 'Oferiți livrare în aceeași zi?',
    'help.delivery.sameDayDeliveryAnswer': 'Da! Comenzile plasate înainte de 20:00 pot fi livrate în aceeași zi în orașele majore. Livrarea în aceeași zi este disponibilă pentru produsele marcate cu "Livrare în aceeași zi disponibilă!"',
    'help.delivery.deliveryAreas': 'Unde livrați?',
    'help.delivery.deliveryAreasAnswer': 'Livrăm în tot judetul Neamț. Timpul de livrare poate varia în funcție de locație.',
    'help.delivery.notHome': 'Ce se întâmplă dacă destinatarul nu este acasă?',
    'help.delivery.notHomeAnswer': 'Echipa noastră de livrare va contacta destinatarul pentru a stabili un moment convenabil. Dacă nu reușim să-l contactăm, te vom contacta pe tine (expeditorul) pentru instrucțiuni suplimentare.',
    
    // Payment
    'help.payment.title': 'Plată',
    'help.payment.paymentMethods': 'Ce metode de plată acceptați?',
    'help.payment.paymentMethodsAnswer': 'Acceptăm:\n- Carduri de Credit/Debit (Visa, Mastercard)\n- Plată online prin euPlatesc - momentan nu este disponibil\n- Plată la livrare\n- Transfer bancar',
    'help.payment.securePayment': 'Este sigură informația mea de plată?',
    'help.payment.securePaymentAnswer': 'Da! Toate plățile online sunt procesate prin conexiuni securizate și criptate. Folosim euPlatesc pentru plățile cu cardul, care este conform PCI DSS. Nu stocăm niciodată detaliile complete ale cardului tău.',
    'help.payment.cashOnDelivery': 'Cum funcționează Plata la Livrare?',
    'help.payment.cashOnDeliveryAnswer': 'Cu Plata la Livrare, plătești curierului în numerar când primești comanda. Această opțiune este disponibilă pentru toate comenzile. Te rugăm să ai suma exactă pregătită, dacă este posibil.',
    
    // Flowers
    'help.flowers.title': 'Îngrijirea Florilor',
    'help.flowers.flowerCare': 'Cum îmi îngrijesc florile?',
    'help.flowers.flowerCareAnswer': 'Sfaturi generale de îngrijire:\n- Schimbă apa zilnic\n- Taie tulpinile la un unghi de 45° la fiecare 2-3 zile\n- Îndepărtează frunzele moarte\n- Ține departe de lumina directă a soarelui\n- Menține temperatura camerei răcoroasă\n',
    'help.flowers.howLong': 'Cât timp țin florile mele?',
    'help.flowers.howLongAnswer': 'Cu îngrijire corespunzătoare, majoritatea buchetelor țin 7-10 zile. Unele flori precum floarea-soarelui pot ține până la 12 zile, în timp ce lalelele de obicei țin 5-7 zile. Fiecare pagină de produs include informații despre durata de viață așteptată.',
    'help.flowers.customBouquet': 'Pot crea un buchet personalizat?',
    'help.flowers.customBouquetAnswer': 'Da! Contactează-ne prin telefon (0769141250) sau email (laurasimona97@yahoo.com sau simonabuzau2@gmail.com) cu preferințele tale pentru culori, tipuri de flori și ocazie. Florarii noștri vor crea un aranjament personalizat pentru tine.',
    'help.flowers.freshness': 'Cum asigurați prospețimea florilor?',
    'help.flowers.freshnessAnswer': 'Ne aprovizionăm zilnic cu flori de la cultivatori locali și internaționali de încredere. Fiecare buchet este inspectat pentru calitate înainte de livrare. Oferim o garanție de prospețime - contactează-ne în termen de 24 de ore dacă nu ești mulțumit.',
    
    // Products
    'help.products.title': 'Produse',
    'help.products.outOfStock': 'Ce fac dacă floarea dorită este epuizată?',
    'help.products.outOfStockAnswer': 'Disponibilitatea florilor variază în funcție de sezon. Dacă un produs este epuizat, putem sugera alternative similare sau te putem notifica când devine disponibil. Contactează-ne pentru recomandări.',
    'help.products.addOns': 'Pot adăuga extra la comandă?',
    'help.products.addOnsAnswer': 'Da! Poți adăuga un mesaj personalizat pe card la orice comandă. Unele produse oferă și opțiuni de vază și alte accesorii. Aceste opțiuni apar la checkout.',
    
    // Account
    'help.account.title': 'Cont & Lista de Dorințe',
    'help.account.wishlist': 'Cum funcționează Lista de Dorințe?',
    'help.account.wishlistAnswer': 'Apasă iconița în formă de inimă de pe orice produs pentru a-l adăuga la Lista de Dorințe. Lista ta de dorințe este salvată în browser, facilitând găsirea și comandarea florilor tale favorite mai târziu.',
    'help.account.orderHistory': 'Pot recomanda din achizițiile anterioare?',
    'help.account.orderHistoryAnswer': 'Poți urmări comenzile folosind numărul de urmărire trimis prin email. Pentru a recomanda, pur și simplu găsește produsul în magazinul nostru și adaugă-l din nou în coș.',
    
    // Still Need Help
    'help.stillNeedHelp.title': 'Mai Ai Nevoie de Ajutor?',
    'help.stillNeedHelp.subtitle': 'Echipa noastră de servicii pentru clienți este aici să te asiste',
    'help.contact.phone': 'Telefon',
    'help.contact.email': 'Email',
    'help.contact.message': 'Trimite Mesaj',
    'help.contact.sendMessage': 'Contactează-ne',

    // Checkout cancel
    'checkout.cancel.title': 'Plata a eșuat',
    'checkout.cancel.paymentFailed': 'Plata a eșuat. Vă rugăm să încercați din nou.',
    'checkout.cancel.paymentCancelled': 'Ați anulat plata.',
    'checkout.cancel.defaultError': 'A apărut o problemă cu plata.',
    'checkout.cancel.whatHappened': 'Ce s-a întâmplat?',
    'checkout.cancel.noCharge': 'Nu ați fost taxat',
    'checkout.cancel.noOrder': 'Comanda nu a fost plasată',
    'checkout.cancel.cartSaved': 'Coșul dvs. este în siguranță',
    'checkout.cancel.commonIssues': 'Probleme comune:',
    'checkout.cancel.insufficientFunds': 'Fonduri insuficiente pe card',
    'checkout.cancel.incorrectDetails': 'Detalii de card incorecte',
    'checkout.cancel.cardNotActivated': 'Cardul nu este activat pentru plăți online',
    'checkout.cancel.connectionIssue': 'Probleme de conexiune',
    'checkout.cancel.autoRedirect': 'Veți fi redirecționat automat în',
    'checkout.cancel.secundă': 'secundă',
    'checkout.cancel.secunde': 'secunde',
    'checkout.cancel.tryAgain': 'Încearcă din nou plata',
    'checkout.cancel.backToCart': 'Înapoi la Coș',
    'checkout.cancel.contactSupport': 'Contactează Suportul',
    'checkout.cancel.commonIssuesTitle': 'Probleme comune:',
    'checkout.cancel.alternativePayment': 'Sau alegeți o altă metodă de plată:',
    'checkout.cancel.bankTransfer': 'Transfer bancar',
    'checkout.cancel.cashOnDelivery': 'Numerar la livrare',
    'checkout.cancel.needHelp': 'Aveți nevoie de ajutor?',
    'checkout.cancel.contactUs': 'Contactați-ne',
  }
};

// Helper function to get translation
export function useTranslation(language: Language) {
  return (key: string): string => {
    return translations[language][key] || key;
  };
}
